// src/store/productManagment/types.ts

import { Product } from '../../dataTypes/productManagment/types';

export const FETCH_PRODUCT_REQUEST = 'FETCH_PRODUCT_REQUEST';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAILURE = 'FETCH_PRODUCT_FAILURE';

export const FETCH_PRODUCT_BY_ID_REQUEST = 'FETCH_PRODUCT_BY_ID_REQUEST';
export const FETCH_PRODUCT_BY_ID_SUCCESS = 'FETCH_PRODUCT_BY_ID_SUCCESS';
export const FETCH_PRODUCT_BY_ID_FAILURE = 'FETCH_PRODUCT_BY_ID_FAILURE';

export const FETCH_PRODUCT_BY_CATEGORY_REQUEST = 'FETCH_PRODUCT_BY_CATEGORY_REQUEST';
export const FETCH_PRODUCT_BY_CATEGORY_SUCCESS = 'FETCH_PRODUCT_BY_CATEGORY_SUCCESS';
export const FETCH_PRODUCT_BY_CATEGORY_FAILURE = 'FETCH_PRODUCT_BY_CATEGORY_FAILURE';

export interface ProductState {
  loading: boolean;
  products: Map<number, Product>;
  error: string | null;
  lastFetchTimestamp: number;
  lastFetchParams: GetProductListParams | null;
}

export const initialState: ProductState = {
  loading: false,
  products: new Map(),
  error: null,
  lastFetchTimestamp: 0,
  lastFetchParams: null,
};

export interface GetProductListParams {
  kind?: string;
  active?: boolean;
  categoryId?: number;
}

export interface FetchProductRequestAction {
  type: typeof FETCH_PRODUCT_REQUEST;
  payload: GetProductListParams;
}

export interface FetchProductSuccessAction {
  type: typeof FETCH_PRODUCT_SUCCESS;
  payload: {
    products: Product[];
    lastFetchTimestamp: number;
    lastFetchParams: GetProductListParams | null;
  };
}

export interface FetchProductFailureAction {
  type: typeof FETCH_PRODUCT_FAILURE;
  payload: string;
}

export interface FetchProductByIdRequestAction {
  type: typeof FETCH_PRODUCT_BY_ID_REQUEST;
}

export interface FetchProductByIdSuccessAction {
  type: typeof FETCH_PRODUCT_BY_ID_SUCCESS;
  payload: Product;
}

export interface FetchProductByIdFailureAction {
  type: typeof FETCH_PRODUCT_BY_ID_FAILURE;
  payload: string;
}

export interface FetchProductByCategoryRequestAction {
  type: typeof FETCH_PRODUCT_BY_CATEGORY_REQUEST;
}

export interface FetchProductByCategorySuccessAction {
  type: typeof FETCH_PRODUCT_BY_CATEGORY_SUCCESS;
  payload: Product[];
}

export interface FetchProductByCategoryFailureAction {
  type: typeof FETCH_PRODUCT_BY_CATEGORY_FAILURE;
  payload: string;
}

export type ProductActionTypes =
  | FetchProductRequestAction
  | FetchProductSuccessAction
  | FetchProductFailureAction
  | FetchProductByIdRequestAction
  | FetchProductByIdSuccessAction
  | FetchProductByIdFailureAction
  | FetchProductByCategoryRequestAction
  | FetchProductByCategorySuccessAction
  | FetchProductByCategoryFailureAction;